import { ApiCallService } from './api-call.service';
import { GtagService } from './../analytics/gtag.service';
import { Agency } from './../models/index';
var AgencyService = /** @class */ (function () {
    function AgencyService(apiCallService) {
        this.apiCallService = apiCallService;
        this._agency = new Agency();
    }
    Object.defineProperty(AgencyService.prototype, "agency", {
        get: function () {
            return this._agency;
        },
        enumerable: true,
        configurable: true
    });
    AgencyService.prototype.getAgency = function () {
        var _this = this;
        var promise = this.apiCallService.get('');
        if (promise) {
            promise.then(function (response) {
                _this._agency = response;
                GtagService.updatePhoneConversion(_this._agency);
            });
        }
        return promise;
    };
    return AgencyService;
}());
export { AgencyService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/agency.service.ts.pre-build-optimizer.js